import { gsap } from 'gsap';
import { init, enter, leave } from '../animations';

export function timeExpiredEnter(el) {
  const content = el.querySelector('.content__text');
  const button = el.querySelector('.content__button');
  const img = el.querySelector('.content__image');
  const tl = gsap.timeline();

  init.get('fade')(content, { y: 30 });
  gsap.set(img, { scale: 0 });
  init.get('buttonRounded')(button);

  tl.addLabel('start')
    .add(enter.get('fade')(content, 0, 0.75), 'start')
    .to('.leaves.leaves--m.leaves--frame', {
      autoAlpha: 1,
      scale: 1,
      duration: 0.75,
      ease: 'power3.out',
    }, 'start')
    .to(img, {
      scale: 1,
      duration: 0.6,
      ease: 'flap',
    }, 'start+=0.2')
    .add(enter.get('buttonRounded')(button), 'start+=0.4');

  return tl;
}

export function timeExpiredLeave(el) {
  const content = el.querySelector('.content__text');
  const img = el.querySelector('.content__image');
  const button = el.querySelector('.content__button');
  const tl = gsap.timeline();

  tl.addLabel('start')
    .add(leave.get('fade')(content, { y: -30 }), 'start')
    .to(img, {
      scale: 0,
      duration: 0.6,
      ease: 'flap',
    }, 'start+=0.2')
    .add(leave.get('buttonRounded')(button), 'start+=0.4');

  return tl;
}
